import styled from "vue-styled-components";

export const Content = styled.div`
    margin-bottom: 2rem;

    > span {
        font-size: 1.6rem;
        font-weight: 500;
        color: ${props => props.theme?.text_site_color ?? '#4a505e'};
        font-family: ${props => props.theme?.font_family ?? 'Open Sans'}, sans-serif;

        &.scratched {
            text-decoration: line-through;
        }

        &.price-product {
            font-size: 2.4rem;
            line-height: 0.8;
            color: ${props => props.theme?.products?.product_page?.price_color ?? '#595959'};            
            font-weight: ${props => props.theme?.products?.product_page?.font_weight_price ?? 700};

            small {
                color: ${props => props.theme?.products?.product_page?.price_color ?? '#595959'};
            }
        }
    }

    small {
        font-size: 1.3rem;
        font-weight: 500;
        color: ${props => props.theme?.text_site_color ?? '#4a505e'};
    }

    .additional-items {
        margin-top: 0.5rem;

        small {
            display: block;            

            &:after {
                content: "+";
            }

            &:last-child::after {
                content: "";
            }
        }
    }
`;
